import React, { Component } from "react";
import Header from "../../../assets/components/header";
import Footer from "../../../assets/components/footer";
import EntityBookingActivityThreshold from "../../../assets/components/reports/EntityBookingActivityThreshold";

class EntityBookingActivityThresholdReport extends Component {
    body() {
        return (
            <div className='container'>
                <div className='row'>
                    <div className='col'>
                        <h2>Entity Booking Activity Threshold</h2>
                    </div>
                </div>

                <div className='row mt-3'>
                    <div className='col'>
                        <EntityBookingActivityThreshold />
                    </div>
                </div>
            </div>
        );
    }

    render() {
        return (
            <>
                <div className='d-flex main'>
                    <Header history={this.props.history} />
                    {this.body()}
                </div>
                <Footer />
            </>
        );
    }
}

export default EntityBookingActivityThresholdReport;
